const DEFAULT_TABLEAU_API_MODULE_PATH = "./lib/tableau.extensions.1.12.0.js";

type KnownTableauApiVersion = "1.12.0" | "1.16.0";

export interface TableauApiLoadOptions {
  /**
   * Loads one of the bundled Tableau API versions.
   */
  version?: KnownTableauApiVersion;
}

let loadPromise: Promise<void> | undefined;

const bundledVersionPaths: Record<KnownTableauApiVersion, string> = {
  "1.12.0": "./lib/tableau.extensions.1.12.0.js",
  "1.16.0": "./lib/tableau.extensions.1.16.0.min.js",
};

function resolveModulePath(options?: TableauApiLoadOptions): string {
  if (options?.version) {
    return bundledVersionPaths[options.version];
  }

  return DEFAULT_TABLEAU_API_MODULE_PATH;
}

async function importTableauApiModule(modulePath: string): Promise<void> {
  switch (modulePath) {
    case "./lib/tableau.extensions.1.12.0.js":
      // @ts-expect-error Bundled vendor file has no TypeScript declarations.
      await import("./lib/tableau.extensions.1.12.0.js");
      return;
    case "./lib/tableau.extensions.1.16.0.min.js":
      // @ts-expect-error Bundled vendor file has no TypeScript declarations.
      await import("./lib/tableau.extensions.1.16.0.min.js");
      return;
    default:
      await import(/* @vite-ignore */ modulePath);
  }
}

export async function ensureTableauApiLoaded(
  options?: TableauApiLoadOptions,
): Promise<void> {
  if (typeof tableau !== "undefined") {
    return;
  }

  if (!loadPromise) {
    const modulePath = resolveModulePath(options);
    loadPromise = importTableauApiModule(modulePath);
  }

  await loadPromise;
}
